module.exports = __webpack_public_path__ + "static/media/Choice.af02b75f.svg";